// First-party, privacy-conscious analytics client. No third-party trackers.
import { API } from "@/lib/api";

const ANON_KEY = "melletic_anon_id";
const SESSION_KEY = "melletic_session_id";
const UTM_KEY = "melletic_utm";

function uid() {
  try {
    return crypto.randomUUID();
  } catch {
    return `id-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

function anonId() {
  let v = localStorage.getItem(ANON_KEY);
  if (!v) {
    v = uid();
    localStorage.setItem(ANON_KEY, v);
  }
  return v;
}

function sessionId() {
  let v = sessionStorage.getItem(SESSION_KEY);
  if (!v) {
    v = uid();
    sessionStorage.setItem(SESSION_KEY, v);
  }
  return v;
}

// Parse + persist UTM/referral params on first visit of a session.
function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {
      source: params.get("utm_source"),
      medium: params.get("utm_medium"),
      campaign: params.get("utm_campaign"),
    };
    if (utm.source || utm.medium || utm.campaign) {
      sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
      return utm;
    }
    const stored = sessionStorage.getItem(UTM_KEY);
    if (stored) return JSON.parse(stored);
  } catch {}
  return {};
}

function currentUser() {
  // best-effort user id (no sensitive data)
  try {
    const token = localStorage.getItem("melletic_token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub || null;
  } catch {
    return null;
  }
}

export function track(event, props = {}) {
  try {
    const body = {
      event,
      event_id: uid(),
      anon_id: anonId(),
      session_id: sessionId(),
      user_id: currentUser(),
      path: window.location.pathname,
      referrer: document.referrer || null,
      utm: captureUtm(),
      props,
    };
    // Non-blocking, keepalive so it survives navigation. Never throws to caller.
    navigator.sendBeacon?.(
      `${API}/analytics/track`,
      new Blob([JSON.stringify(body)], { type: "application/json" })
    ) ||
      fetch(`${API}/analytics/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch(() => {});
  } catch {}
}

export function trackPageview() {
  track("pageview");
}
